import React from 'react';
import './footer.css'
import logo from '../../assets/logo.png'
import pic37 from '../../assets/pic37.png'
import pic38 from '../../assets/pic38.png'
import pic39 from '../../assets/pic39.png'
import Footerheader from '../common/footer-header';
import Navfooter from '../common/footernav';

const Footer = () => {
    return ( 
        <footer className='footer'>
            <nav className='big-cont-footer '>
                <nav className='main-container-footer'>
                    <nav className='container-row-footer'>
                            <article className='left-box-footer'>
                                <img src={logo} alt='pic'></img>
                                <p className='paragraph-footer'>A tribute to Coco
                                     Chanel — a visionary designer whose bold ideas
                                      redefined fashion and empowered generations
                                       of women with elegance and confidence.</p>
                                <nav className='icons-cont'>
                                    <img className='icons' src={pic37} alt='icon'></img>
                                     <img className='icons' src={pic38} alt='icon'></img>
                                      <img className='icons' src={pic39} alt='icon'></img>
                                </nav>
                            </article>


                            <nav className='container-navs'>
                                <nav className='navigation-container-footer'>
                                    <Footerheader title='Quick links' />
                                    <ul className='list-footer'>
                                        <Navfooter title='Home'/>
                                        <Navfooter title='About'/>
                                        <Navfooter title='Facts'/>
                                    </ul>
                                </nav>  



                                <nav className='navigation-container-footer'>
                                    <Footerheader title='Legal' />
                                    <ul className='list-footer'>
                                        <Navfooter title='Terms & Conditions'/>
                                        <Navfooter title='Cookies'/>
                                        <Navfooter title='Privacy Policy'/>
                                    </ul>
                                </nav>  



                            </nav>
                    </nav>


                    <article className='last-part-footer'>
                            <h3 className='last-text-footer'>@2026,FashionIdol,AllRightsReservedbyFashionIdol</h3>
                    </article>



                </nav>
            </nav>
        </footer>
     );
}
 
export default Footer;